import React from "react";
import PropTypes from "prop-types";
import { css } from "react-emotion";
import cuid from "cuid";

const propTypes = {
  noBlur: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  children: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {
  checked: false,
  disabled: false,
  noBlur: false,
  className: undefined,
};
/**
 * Checkbox component
 * <Checkbox
 *  name="item"
 *  value={item.id}
 *  checked={this.state.checked[item.id]}
 *  onChange={this.handleCheck}
 *  disabled={
 *    this.state.rightSide.elements[item.id] !== undefined
 *  }
 *\/>
 */
class Checkbox extends React.Component {
  id = cuid();
  renderContent = content => {
    const { children } = this.props;
    if (typeof children === "function") {
      return children({ input: content, id: this.id });
    }
    return content;
  };
  render() {
    const {
      checked,
      value,
      name,
      onChange,
      disabled,
      className,
      noBlur,
      onFocus,
      onBlur,
    } = this.props;
    const statusClass = checked ? "checked" : "unchecked";
    const disabledClass = disabled && !noBlur ? disabledOpacity : "";

    return this.renderContent(
      <div className={className}>
        <input
          type="checkbox"
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          checked={checked}
          className={inputStyle}
          onFocus={onFocus}
          onBlur={onBlur}
          id={this.id}
        />
        <label htmlFor={this.id} className={`checkbox ${statusClass} ${disabledClass}`} />
      </div>
    );
  }
}

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
export default Checkbox;

const disabledOpacity = css`
  opacity: 0.3;
`;

const inputStyle = css`
  /* visibility: visible !important; */
  display: none !important;
  /* opacity: 0; */
  + label {
    transition: 100ms;
    position: static;
    top: auto;
    left: auto;
    display: block;
  }
  :focus + label {
    transform: scale(1.1);
  }
`;



// WEBPACK FOOTER //
// ./src/components/form/Checkbox.jsx